import type { IDateTimeFilterAddition, GButtonProps, DateTimeFilter } from '~/presentation/ui';
import type { ButtonProps, PopoverProps } from '@shopify/polaris';

import { CompareTimePicker } from './components/CompareTimePicker';
import { MainTimePicker } from './components/MainTimePicker';
import { InlineStack } from '@shopify/polaris';

export interface GTimePickerProps {
  rangeAddition?: IDateTimeFilterAddition;
  popoverProps?: Partial<PopoverProps>;
  isCompare?: boolean;
  activator?: (props: { onClick: () => void; value?: string }) => React.ReactElement;
  onApply?: (value: DateTimeFilter) => void;
  activatorProps?: Pick<ButtonProps, 'disabled' | 'loading' | 'size'>;
  actionProps?: GButtonProps;
}

export const GTimePicker: React.FC<GTimePickerProps> = (props) => {
  const { isCompare, ...timePickerProps } = props;

  return (
    <InlineStack gap="200">
      <MainTimePicker {...timePickerProps} />
      {isCompare && (
        <CompareTimePicker
          rangeAddition={timePickerProps.rangeAddition}
          popoverProps={timePickerProps.popoverProps}
        />
      )}
    </InlineStack>
  );
};
